// src/app/views/pages_pub/g7/rtPbG7.js
import Loadable from "app/components/Loadable";
import { lazy } from "react";
import { getPathByCdExt } from "app/utils/utils";
import { EXAM_TYPES } from "app/types/examTypes";

const G7Land = Loadable(lazy(() => import("./G7Land")));
const G7Apply = Loadable(lazy(() => import("./G7Apply")));
// const G7ApplyVeritas = Loadable(lazy(() => import("./G7ApplyVeritas")));
const G7ApplyPsatCamp = Loadable(lazy(() => import("./G7ApplyPsatCamp")));
const pathExt = getPathByCdExt(EXAM_TYPES.G7.rid_cd_ext);

const rtPbG7 = [
  { path: `/pub/${pathExt}/land/:rid_cd_ext/:rid_imp_sr`, element: <G7Land /> },
  { path: `/pub/${pathExt}/apply/:rid_cd_ext/:rid_imp_sr`, element: <G7Apply /> },
  // { path: `/pub/${pathExt}/apply-veritas/:rid_cd_ext/:rid_imp_sr`, element: <G7ApplyVeritas /> },
  { path: `/pub/${pathExt}/app_psat_camp`, element: <G7ApplyPsatCamp /> }
];
export default rtPbG7;
